// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { DateTime, IANAZone } from 'luxon';

/**
 * Returns a file name for a report by appending the current date and time in
 * the provided timezone to the given prefix. The file name does not include a
 * file extension.
 *
 * @param reportPrefix - A prefix for the report file name.
 * @param timezone - The timezone to use for the date and time.
 */
export function getReportFileName(reportPrefix: string, timezone: IANAZone) {
  const dateTime = DateTime.now().setZone(timezone);
  const formattedDateTime = dateTime.toFormat('yyyy-MM-dd_HH-mm-ss');

  return `${reportPrefix}_${formattedDateTime}`;
}
